var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-img",style:(_vm.styles)},[_c('el-image',{attrs:{"lazy":_vm.lazy,"src":_vm.srcPath},on:{"load":(e) => _vm.$emit('load', e),"error":(e) => _vm.$emit('error', e)}}),(_vm.auth)?_c('AuthMark',{staticClass:"auth-mark"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }